// ============================================================
// audio/musicOg.js — (legacy) OG chill procedural music
// ============================================================
// Delegates to the single CHILL MUSIC track. Idempotent — never restarts.
import { startMusic } from './musicChill.js';

export function startOgMusic() { startMusic(); }
export function stopOgMusic()  { /* no-op — chill track stays playing */ }
